module.exports = __webpack_public_path__ + "img/ZB52_01.9afc5a33.jpg";